import {deleteMethod, getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/orderDestinations', request)

    // TODO tmp mock
    // return new Promise(resolve => {
    //     resolve({orderDestinations: [{id: 1, cityId: 8885, serviceIds: [1003481]}]})
    // })
}

async function put(id, request) {
    return await putMethod(`/api/orderDestinations/${id}`, request)
}

async function post(id, request) {
    return await postMethod(`/api/orderDestinations/${id}`, request)
}

async function remove(id) {
    return await deleteMethod(`/api/orderDestinations?id=${id}`)
}

export {get, put, post, remove}
